import axios from 'axios';
import { env } from '../../env.config';

// Portal API không cần JWT, tạo instance riêng
const portalApi = axios.create({
  baseURL: env.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface PortalCustomer {
  id: number;
  code: string;
  name: string;
  loyalty_percentage?: number;
}

export interface PortalSummary {
  total_debt: number;
  paid_this_month: number;
}

export interface PortalLoyaltySummary {
  year: number;
  percentage: number;
  total_purchase_value: number;
  receipt_count: number;
  points_earned: number;
}

export interface PortalReceipt {
  id: number;
  voucher_number: string;
  total_amount: number;
  status: string;
  created_at: string;
  completed_at: string | null;
  item_count: number;
  loyalty_points?: number;
}

export interface PortalDebt {
  id: number;
  stock_out_voucher_id: number | null;
  debt_amount: number;
  paid_amount: number;
  status: 'unpaid' | 'partial' | 'paid';
  created_at: string;
  updated_at: string;
  voucher_number: string | null;
  voucher_date: string | null;
  voucher_total: number | null;
  payments: PortalDebtPayment[];
}

export interface PortalDebtPayment {
  id: number;
  customer_debt_id: number;
  payment_date: string;
  amount: number;
  note?: string;
  created_at: string;
}

export interface PortalData {
  customer: PortalCustomer;
  summary: PortalSummary;
  loyalty?: PortalLoyaltySummary;
  receipts: PortalReceipt[];
  debts: PortalDebt[];
}

export interface ReceiptItem {
  id: number;
  medicine_id: number;
  medicine_name: string;
  medicine_code: string;
  unit: string;
  lot_number?: string;
  quantity: number;
  unit_price: number;
  notes?: string;
}

export interface ReceiptDetail {
  voucher: {
    id: number;
    voucher_number: string;
    total_amount: number;
    status: string;
    created_at: string;
    completed_at: string | null;
  };
  items: ReceiptItem[];
}

export const customerPortalService = {
  // Lấy dữ liệu portal (customer, summary, receipts, debts)
  getPortalData: async (token: string, password: string): Promise<PortalData> => {
    const response = await portalApi.get('/api/portal', {
      params: { token, password },
    });
    return response.data.data;
  },

  // Lấy chi tiết phiếu xuất hàng
  getReceiptDetail: async (token: string, receiptId: number, password: string): Promise<ReceiptDetail> => {
    const response = await portalApi.get(`/api/portal/receipts/${receiptId}`, {
      params: { token, password },
    });
    return response.data.data;
  },

  // Lấy danh sách công nợ với filter
  getDebts: async (token: string, password: string, filters?: { month?: string; year?: string }): Promise<PortalDebt[]> => {
    const response = await portalApi.get('/api/portal/debts', {
      params: { token, password, ...filters },
    });
    return response.data.data;
  },
};
